import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import Dashboard from '../components/dashboard';
import { push } from 'connected-react-router';
import { connect } from 'react-redux';
import ContactUsModal from '../components/ContactUsModal';
import { isDate } from 'moment';
import { policySelector, claimSelector, profileSelector } from '../selectors';
import * as claimActions from '../actions/claimActions';
import ReportClaimModal from '../components/sections/claim/ReportClaimModal';
import ConfirmationModal from '../components/sections/claim/ConfirmationModal';

class DashboardContainer extends Component {
	constructor(props) {
		super(props);
		this.contentClicked = this.contentClicked.bind(this);
		this.state = {
			showReportModal: false,
			confirmationDialog: false,
			showContactUsModal: false,
		};
		this.onReportClaim = this.onReportClaim.bind(this);
		this.onReportClaimFieldChange = this.onReportClaimFieldChange.bind(this);
		this.onCancelReportClaim = this.onCancelReportClaim.bind(this);
		this.onShowReportClaimModal = this.onShowReportClaimModal.bind(this);
	}

	
	componentDidUpdate() {
		const { deepLink, onDeepLinkComplete } = this.props;

		if (deepLink && deepLink.action === 'help') {
			this.setState({ showContactUsModal: true });
			if (onDeepLinkComplete) onDeepLinkComplete()
		}
	}

	contentClicked(e) {
		e.preventDefault();
	}

	async onReportClaim(e) {
		try {
			const { actions, claim } = this.props;
			await actions.submitClaim(claim);
			this.setState({ showReportModal: false, reportError: null });
			this.setState({ confirmationDialog: true });
		} catch (error) {
			this.setState({ reportError: error.message });
		}
	}
	onShowReportClaimModal(e) {
		const { actions, claim, profile } = this.props;
		claim.policyHolder = profile.name;
		claim.emailAddress = profile.email;
		claim.phoneNumber = profile.phoneNumber;
		actions.updateClaim(claim);
		this.setState({ showReportModal: true });
	}
	onCancelReportClaim(e) {
		const { actions } = this.props;
		this.setState({ showReportModal: false });
		actions.resetClaim();
	}

	onReportClaimFieldChange(e, data) {
		const { actions, claim } = this.props;
		if (isDate(e)) {
			claim.lossDate = e;
		} else if (!data) {
			claim[e.target.name] = e.target.value;
		} else {
			if (data.name === 'policyNumber') {
				const lossType = (v) => {
					switch (v.substring(0, 3)) {
						case 'PPA':
						case 'CAP':
							return [
								{
									key: 'Auto',
									text: 'Auto',
									value: 'Auto',
								},
							];
						case 'BOP':
						case 'CRM':
						case 'DFR':
						case 'FAR':
						case 'HOM':
							return [
								{
									key: 'Person',
									text: 'Person/Liability',
									value: 'Person',
								},
								{
									key: 'Property',
									text: 'Property',
									value: 'Property',
								},
							];
						case 'CGL':
						case 'CUP':
						case 'PUP':
						case 'FUP':
							return [
								{
									key: 'Person',
									text: 'Person/Liability',
									value: 'Person',
								},
							];
						case 'CIM':
						case 'CPR':
						case 'PIM':
							return [
								{
									key: 'Property',
									text: 'Property',
									value: 'Property',
								},
							];
						case 'GAR':
							return [
								{
									key: 'Person',
									text: 'Person/Liability',
									value: 'Person',
								},
								{
									key: 'Auto',
									text: 'Auto',
									value: 'Auto',
								},
							];
						case 'CPP':
							return [
								{
									key: 'Person',
									text: 'Person/Liability',
									value: 'Person',
								},
								{
									key: 'Auto',
									text: 'Auto',
									value: 'Auto',
								},
								{
									key: 'Property',
									text: 'Property',
									value: 'Property',
								},
							];
						default:
							return [];
					}
				};
				claim.lossTypeOptions = lossType(data.value);
			}
			if (data.type === 'checkbox') {
				claim[data.name] = data.checked;
			} else {
				claim[data.name] = data.value;
			}
		}
		actions.updateClaim(claim);
	}

	render() {
		const { onClick, mobileShow } = this.props;
		const { policy, claim, profile } = this.props;
		const { showReportModal, reportError, showContactUsModal } = this.state;
		return (
			<Dashboard mobileShow={mobileShow}>
				<Dashboard.Row>
					<Dashboard.Col>
						<Dashboard.Button id='dashboardPayNowBtn' href='/paynow' onClick={onClick} label='PAY NOW' icon='credit card alternative' color='darkblue' size='huge' />
					</Dashboard.Col>
					<Dashboard.Col>
						<Dashboard.Button id='dashboardPaymentsBtn' href='/payments' onClick={onClick} onContentClicked={this.contentClicked} label='PAYMENTS' icon='money bill alternate outline' color='blue' size='huge' />
					</Dashboard.Col>
					<Dashboard.Col className='mobile only'>
						<Dashboard.Button id='dashboardMobilePoliciesBtn' href='/policies' onClick={onClick} label='POLICIES' icon='list layout' color='red' size='huge' />
					</Dashboard.Col>
					<Dashboard.Col className='mobile only'>
						<Dashboard.Button id='dashboardMobileAutoIdCardsBtn' href='/autoidcards' label='AUTO ID CARDS' onClick={onClick} icon='car side' color='yellowish' size='huge' />
					</Dashboard.Col>
					<Dashboard.Col>
						<Dashboard.Button id='dashboardClaimsBtn' className='claim' href='/claims' onClick={onClick} label='VIEW CLAIMS' icon='folder open' color='orange' size='huge' />
					</Dashboard.Col>

					<Dashboard.Col className='half'>
						<Dashboard.Button id='dashboardAgencyBtn' className='tablet only computer only' href='/agency' onClick={onClick} label='MY AGENCY' icon='home' color='gray' size='huge' />
					</Dashboard.Col>
				</Dashboard.Row>
				<Dashboard.Row>
					<Dashboard.Col>
						<Dashboard.Button id='dashboardPoliciesBtn' className='tablet only computer only' href='/policies' onClick={onClick} label='POLICIES' icon='list layout' color='red' size='huge' />
					</Dashboard.Col>
					<Dashboard.Col>
						<Dashboard.Button id='dashboardAutoIdCardsBtn' className='tablet only computer only' href='/autoidcards' label='AUTO ID CARDS' onClick={onClick} icon='car side' color='yellowish' size='huge' />
					</Dashboard.Col>
					<Dashboard.Col>
						<Dashboard.Button id='dashboardReportClaimBtn' label='REPORT A CLAIM' icon='handshake' color='green' size='huge' href='/report-claim' />
					</Dashboard.Col>
					<Dashboard.Col className='mobile only'>
						<Dashboard.Button id='dashboardMobileProfileBtn' href='/profile' onClick={onClick} label='PROFILE' icon='user' color='teal' size='huge' />
					</Dashboard.Col>
					<Dashboard.Col className='mobile only'>
						<Dashboard.Button id='dashboardMobileAgencyBtn' href='/agency' onClick={onClick} icon='home' color='gray' label='MY AGENCY' size='huge' />
					</Dashboard.Col>
					<Dashboard.Col className='mobile only'>
						<ContactUsModal open={showContactUsModal} onOpen={() => this.setState({ showContactUsModal: true })} onClose={
							() =>
						
							this.setState({ showContactUsModal: false })
							} trigger={<Dashboard.Button id='dashboardMobileHelpBtn' icon='comments' color='slate' label='CONTACT US' size='huge' />} />
					</Dashboard.Col>
					<Dashboard.Col className='mobile only'>
						<Dashboard.Button id='dashboardMobileLogoutBtn' href='/logout' onClick={onClick} icon='lock' color='slate' label='LOG OUT' size='huge' />
					</Dashboard.Col>
					<Dashboard.Col className='half'>
						<ContactUsModal open={showContactUsModal} onOpen={() => this.setState({ showContactUsModal: true })} onClose={() => this.setState({ showContactUsModal: false })} trigger={<Dashboard.Button id='dashboardHelpBtn' className='tablet only computer only' label='CONTACT US' icon='comments' color='slate' size='huge' />} />
					</Dashboard.Col>
				</Dashboard.Row>
				<ReportClaimModal error={reportError} open={showReportModal} onCancel={this.onCancelReportClaim} onReportClaim={this.onReportClaim} onFieldChange={this.onReportClaimFieldChange} data={{ policy, claim, profile }} />
				<ConfirmationModal showAlertOnly open={this.state.confirmationDialog} onClose={() => this.setState({ confirmationDialog: false })} onOpen={() => this.setState({ confirmationDialog: true })} header='Claim Confirmation'>
					<p>You have successfully submitted your claim! We will be in touch soon.</p>
				</ConfirmationModal>
			</Dashboard>
		);
	}
}
const mapStateToProps = (state, ownProps) => {
	return {
		policy: policySelector(state),
		profile: profileSelector(state),
		claim: claimSelector(state),
	};
};

const mapDispatchToProps = (dispatch) => ({
	actions: {
		...bindActionCreators({ push }, dispatch),
		...bindActionCreators(claimActions, dispatch),
	},
});
DashboardContainer.propTypes = {
	onClick: PropTypes.func.isRequired,
};

export default connect(mapStateToProps, mapDispatchToProps)(DashboardContainer);
